import { render } from "./App.vue?vue&type=template&id=a0c287e2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a0c287e2&scoped=true&lang=css"

import exportComponent from "/opt/dev/private_dev/martin-counter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c287e2"]])

export default __exports__